export default __webpack_public_path__ + "static/media/PremierLeague.aeb08d89.png";